import axios from "axios";
import { constants } from "@/shared";

const { integrations, viacep, cnpja, minhareceita } = constants;

export var http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    Authorization: "bearer " + localStorage.getItem("token_admin"),
  },
});

export var http_mkt = axios.create({
  baseURL: process.env.VUE_APP_MARKETING_URL,
})

export var http_app = axios.create({
  baseURL: process.env.VUE_APP_API_MOBILE_URL,
  headers: {},
});

export var http_crm = axios.create({
  baseURL: integrations.base_url,
  headers: {},
});

export var http_campaign = axios.create({
  baseURL: process.env.VUE_APP_NEST_CAMPAIGN,
  headers: {},
});

export const api = {
  integrations: axios.create({
    baseURL: integrations.base_url,
  }),

  viaCep: axios.create({
    baseURL: viacep.base_url,
    headers: {},
  }),

  cnpja: axios.create({
    baseURL: cnpja.base_url,
    headers: {
      Authorization: cnpja.token,
    },
  }),

  minhaReceita: axios.create({
    baseURL: minhareceita.base_url,
    headers: {},
  }),
};
